const apiKey = "0FF4ECBB-7B7D-434E-BAFA-B40B1481DA39";
const apiUrl = 'https://tapi.rthibert.com/api/CarLightingDistrict/Vehicle/';
 
window.onload = year();
  
function year(){
  
const dataYear = fetch(apiUrl+'Years', {

  method: 'GET',
  headers: {     
    "content-encoding": "gzip", 
 	"content-length": "308",
    "content-type": "application/json; charset=utf-8", 
 	"date": "Fri,03 Dec 2021 18:11:31 GMT",
 	"request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
    "server": "Microsoft-IIS/10.0",
    "vary": "Accept-Encoding", 
 	"x-powered-by": "ASP.NET",
    "accept": "text/plain",
    "x-api-key": apiKey,
    "Authorization": apiKey
    }
})
.then(res => res.json())
.then(data => { data.forEach(yearData => {
  		var vehicleYear = document.getElementById("vehicle-year");
  		var option = document.createElement("option");
        option.value = yearData;
        option.innerText = yearData;
        if(vehicleYear != null){
  		vehicleYear.append(option);
        }
	})
})
.catch( error => {
  console.log(error);
  year();
});

}

$( document ).ready(function() {
  console.log('ready');
const vehicleYear = $("#vehicle-year");
const vehicleMake = $("#vehicle-make");
const vehicleModel = $("#vehicle-model");

  vehicleYear.on('change', function(){ 
    
    
    localStorage.setItem('GYear',vehicleYear.val());
    
    fetch(apiUrl+'Makes/'+vehicleYear.val(), {
      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "308",
        "content-type": "application/json; charset=utf-8", 
        "date": "Fri,03 Dec 2021 18:11:31 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
        }
    })
    .then(response => response.json())
    .then(data => { data.forEach(makeData => {
  		var option = document.createElement("option");
        option.value = makeData;
        option.innerText = makeData;
        if(vehicleMake != null){
          vehicleMake.append(option);
          }
        })
    });

    setTimeout(function(){
		vehicleMake.focus();
    }, 100); 
    
    vehicleMake.removeAttr("disabled");
    vehicleModel.attr("disabled", true);
    vehicleMake.html('');
    var option = document.createElement("option");
    option.value = 'Make';
    option.innerText = 'Make';
    vehicleMake.append(option);
    vehicleModel.html('');
    var option2 = document.createElement("option");
    option2.value = 'Model';
    option2.innerText = 'Model';
    vehicleModel.append(option2);
    $('.gvsearchbtn').addClass("disabled");
    
  });
   
  
  vehicleMake.on('change', function(){ 
    vehicleModel.removeAttr("disabled");
    vehicleModel.html('');
    var option = document.createElement("option");
    option.value = 'Model';
    option.innerText = 'Model';
    vehicleModel.append(option);
    
    localStorage.setItem('GMake',vehicleMake.val());
    fetch(apiUrl+'Models/'+vehicleYear.val()+'/'+vehicleMake.val(), {
      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "308",
        "content-type": "application/json; charset=utf-8", 
        "date": "Fri,03 Dec 2021 18:11:31 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
        }
    })
    .then(response => response.json())
    .then(data => { data.forEach(modelData => {
  		var option = document.createElement("option");
        option.value = modelData;
        option.innerText = modelData;
        if(vehicleModel != null){
          vehicleModel.append(option);
          }
        })
    });
    
    setTimeout(function(){
		vehicleModel.focus();
    }, 100); 
    $('.gvsearchbtn').addClass("disabled");
  });

  
  vehicleModel.on('change', function(){ 
    
    localStorage.setItem('GModel',vehicleModel.val());
    $('.gvsearchbtn').removeClass("disabled");
    $varHref = '/pages/product-results?year='+vehicleYear.val()+'&make='+vehicleMake.val()+'&model='+vehicleModel.val();
    //$varHref = '/pages/product-results';
    $('.gvsearchbtn').attr("href", $varHref);
    $('.gvsearchbtn').removeAttr('target');
    
  });
  
  $('.gv-ptheader-btn').click(function() {
  	alert( "Handler for .click() called." );
	});
});

